'use client'
import { useEffect, useRef } from 'react'

interface LusAdDisplayProps {
  site?: string
  containerId?: string
  className?: string
  sessionId?: string
}

export function LusAdDisplay({
  site = 'd.fo',
  containerId = 'lus-ad-container',
  className = '',
  sessionId,
}: LusAdDisplayProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const initializeRef = useRef(false)

  useEffect(() => {
    // Prevent multiple initializations
    if (initializeRef.current) {
      return
    }

    // Check if script already exists
    const existingScript = document.querySelector(
      'script[src*="lus-tracker.js"]'
    )
    if (existingScript) {
      initializeRef.current = true
      return
    }

    // Load LUS tracker script (use API route for CORS support)
    const script = document.createElement('script')
    script.src = 'https://lus.fo/api/tracker'
    script.setAttribute('data-site', site)
    script.setAttribute('data-container', containerId)

    // Pass external site's sessionId if provided
    if (sessionId) {
      script.setAttribute('data-session-id', sessionId)
    }

    // API base will be auto-detected by the tracker script

    script.onload = () => {
      initializeRef.current = true
    }

    script.onerror = () => {
      // Show simple fallback content
      if (containerRef.current) {
        containerRef.current.innerHTML = `
          <div style="
            padding: 20px;
            text-align: center;
            color: #666;
            border: 2px dashed #ddd;
            border-radius: 8px;
            background: #f9f9f9;
          ">
            <p>Advertisement could not be loaded</p>
          </div>
        `
      }
    }

    document.head.appendChild(script)

    // Cleanup function
    return () => {
      // Note: Don't remove script as it may be shared across components
    }
  }, [site, containerId, sessionId])

  return (
    <div
      ref={containerRef}
      id={containerId}
      className={className}
      style={{
        width: '100%',
        maxWidth: '1000px',
      }}
    />
  )
}
